export default __webpack_public_path__ + "static/media/grow-crypto.1b4623d5.svg";